import React from 'react'
import CardsBasicInformation from '../CardsBasicInformation/CardsBasicInformation'
import UsersInformation from './UsersInformation'
import { useSelector } from 'react-redux'
import UnitOfLearnings from './UnitOfLearnings'

const FormPreview = ({ showHeader = true, className='max-h-screen-modal-content overflow-auto' }) => {
  const formData = useSelector((state) => state?.class?.form || {})
  const permissionsList = useSelector((state) => state?.session?.permissions?.class?.list || [])
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );
  return (
    <div className={className}>
      { showHeader && (
        <div className='sticky top-0px left-0px bg-background w-full z-12'>
          <CardsBasicInformation />
        </div>
      )}
      <UsersInformation type='Teachers' items={formData.teachers} />
      { (permissionsList.includes('all') || permissionsList.includes('by-teacher') )  && 
        <UsersInformation type='Students' items={formData.students} />
      }
      {
        existLinceseAssessment && formData.curriculumId &&
        <UnitOfLearnings items={formData.unitOfLearnings || []} curriculumId={formData.curriculumId} />
      }
    </div>
  )
}

export default FormPreview